import { render, staticRenderFns } from "./topBar.vue?vue&type=template&id=dca39650&scoped=true&"
import script from "./topBar.vue?vue&type=script&lang=js&"
export * from "./topBar.vue?vue&type=script&lang=js&"
import style0 from "./topBar.vue?vue&type=style&index=0&id=dca39650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca39650",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default})
